import request from '@/utils/request';

let getRoleList=(data)=>request.post('/api/role/list',data)
let addRole=(data)=>request.post('/api/role/add',data)
let editRole=(data)=>request.post('/api/role/edit',data)
let deleteRole=(data)=>request.get('/api/role/delete',data)

export default{
  getRoleList,
  addRole,
  editRole,
  deleteRole
}